
import React from 'react';

interface MagicBackgroundStyleProps {
  enabled: boolean;
  color: string;
}

export const getMagicBackgroundStyle = ({ 
  enabled, 
  color 
}: MagicBackgroundStyleProps): React.CSSProperties => {
  if (!enabled) return {};
  
  return {
    background: `linear-gradient(125deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 40%),
                radial-gradient(circle at 60% 30%, ${color}15 0%, transparent 20%),
                radial-gradient(circle at 20% 80%, ${color}10 0%, transparent 20%)`,
    animation: 'gradient 15s ease infinite',
  };
};

interface MagicBackgroundElementsProps {
  show: boolean;
  color: string;  // Added color prop to match usage in SectionLayout
}

export const MagicBackgroundElements: React.FC<MagicBackgroundElementsProps> = ({ show, color }) => {
  if (!show) return null;
  
  return (
    <>
      <div className="absolute top-1/4 left-1/4 w-1/3 h-1/3 rounded-full bg-gradient-to-br from-transparent to-white/5 blur-3xl animate-float opacity-50"></div>
      <div 
        className="absolute bottom-1/4 right-1/4 w-1/4 h-1/4 rounded-full bg-gradient-to-br from-transparent to-white/5 blur-3xl animate-float opacity-30" 
        style={{ animationDelay: '2s' }}
      ></div>
    </>
  );
};
